import { useContent } from "@/i18n";

export const Marquee = ({ dark = false, items = null }) => {
  const { c } = useContent();
  const list = items || c.marqueeItems;
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y select-none ${
        dark ? "border-cream/15 bg-choco text-cream" : "border-line bg-ivory text-choco"
      }`}
    >
      <div className="marquee-track py-5">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {list.map((item, i) => (
              <span key={i} className="flex items-center font-serif italic text-2xl md:text-3xl tracking-tight">
                <span className="px-8">{item}</span>
                <span className={`${i % 2 === 0 ? "text-cobalt" : dark ? "text-cream/40" : "text-choco/40"} not-italic text-xl`}>✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
